import { debounce } from 'lodash'
import PropTypes from 'prop-types'
import { Component } from 'react'

import cn from '@/utilities/cn'

import './index.scss'

/**
 * @deprecated Please update to `{ ImagePreview }`
 */
export default class ImagePreview extends Component<any, any> {
  static displayName = 'ImagePreview'

  static propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    imageUrl: PropTypes.string,
    size: PropTypes.string,
    title: PropTypes.string,
    onError: PropTypes.func
  }

  static defaultProps = {
    className: '',
    id: null,
    imageUrl: '',
    size: '50px',
    title: '',
    onError: undefined
  }

  state = { objectUrl: null }

  componentDidMount() {
    if (this.props.id) {
      this.setState({ objectUrl: this.props.imageUrl })
    }
  }

  componentDidUpdate(prevProps: any) {
    if (prevProps.imageUrl !== this.props.imageUrl && this.props.id) {
      this.updateUrl(this.props.imageUrl)
    }
  }

  updateUrl = debounce(value => {
    this.setState({ objectUrl: value })
  }, 700)

  onError = () => {
    this.props.onError && this.props.onError()
    this.setState({ objectUrl: null })
  }

  render() {
    const { className, size, title } = this.props

    if (!this.state.objectUrl) {
      return <div className={cn('image_preview', className)} />
    }

    return (
      <img
        className={cn('image_preview', className)}
        onError={this.onError}
        src={this.state.objectUrl}
        width={size}
        height={size}
        alt={title}
      />
    )
  }
}

// Updated version that uses typical HTML properties

export { default as ImagePreview } from './ImagePreview'
